module.exports = "/virtual-football-league/img/amblems/left/Italy/Fake_Juventus.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Italy/Fake_Juventus.png
// module id = 2040
// module chunks = 4